import {RelatedSoftware} from "./related-software.model";

export const relatedSoftwareMock: RelatedSoftware = {
  activated: true,
  exclusive: false,
  categories: [
    {
      identifier: "gc20",
      label: "agriculture"
    },
    {
      identifier: "sc123",
      label: "sub category 1"
    },
    {
      identifier: "sc124",
      label: "sub category 2"
    },
  ],
  software: [
    {
      name: "soft",
      urlAlias: "soft",
      path: "/path/to/soft",
      id: "42",
      isSent: false
    }
  ]
};
